(function(){
    'use strict';

    angular
        .module('app.contact')
        .controller('WorkUsController', WorkUsController);

    function WorkUsController(API, $state) {
        let vm = this;

        vm.vagas = [];
		vm.semVagas = false;

		vm.$onInit = () => {
		  _loadFromApi();
		}

		function _loadFromApi() {
		  _loadVagas();
		}

		function _loadVagas() {
		  API.get(`vagas`)
				.then(result => result.data)
				.then(vagas => vm.vagas = vagas)
				.then(() => vm.semVagas = vm.vagas.length ? true : false)
				.catch(error => {
				  vm.semVagas = true;
				  console.log(error, 'error');
				});
		}

    vm.submitWorkUs = (workUs) => {
	    API.postFile(`workUs`, workUs)
		   .then(result => swal('Enviado com sucesso!', '', 'success'))
		   .then((result) => {
		   		vm.ItsOkayForm.$submitted = false;
		   		angular.copy({}, workUs)
  				vm.ItsOkayForm.$submitted = false;
  				vm.ItsOkayForm.$setPristine();
		   })
		   .catch(error => {
    			console.log(error, 'error');
    			swal({title: 'Opss...!', text: 'Tente novamente!', type: 'error'}).then(() => $state.reload());
		   });
      }
    }

})();
